import { motion as FMotion } from 'framer-motion'

export const motion = {
  ...FMotion,
  View: FMotion.div,
}
